<template>
  <div id="carousel1" class="carousel slide carousel-dark p-0" data-bs-ride="carousel" data-bs-touch="true">
    <div class="carousel-indicators">
      <button type="button" v-for="(p,idx) in data.cites" :key="idx" data-bs-target="#carousel1" :data-bs-slide-to="idx" :class="idx==0 ? `active` : ``" :aria-current="idx==0" :aria-label="`Slide ` + idx"></button>
      <!-- <button type="button" data-bs-target="#carousel1" data-bs-slide-to="1" aria-label="Slide 2"></button>
      <button type="button" data-bs-target="#carousel1" data-bs-slide-to="2" aria-label="Slide 3"></button> -->
    </div>
    <div class="carousel-inner background-gradient-red text-center">
      <SvgImage :src="data.icon" clazz="margin-bottom-9 margin-top-20 margin-bottom-20 width-65 center"></SvgImage>
      <div v-for="(p,idx) in data.cites" class="carousel-item" :key="idx" :class="(idx==0 ? 'active' : '')">
        <div class="f16-l21 color-white margin-top-50 text-center df20-l26" style="margin-top:100px">{{ p.text }}</div>
        <div class="f17-l23-m color-white red-link text-center df27-l27-m dpadding-tb-20">{{p.name}} </div>
      </div>
    </div>
    <!-- <button class="carousel-control-prev" type="button" data-bs-target="#carousel1" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">קודם</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carousel1" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">הבא</span>
    </button> -->

  </div>
</template>
<script>
// /*global bootstrap*/
import SvgImage from "@/components/generic/SvgImage"
export default {
  components: {
    SvgImage
  },
  props: {
    data: Object
  }

}
</script>
<style scoped>
.background-gradient-red {
  height: 250px;
  width: 100%;
  padding: 0 20px;
  border-radius: 16px;
  background: radial-gradient(circle, #ff7881 0%, #ef3d49 100%);
  box-shadow: 5px 8px 13px -1px rgba(0, 0, 0, 0.13);
}

.carousel-indicators button {
  background-color: white !important;
  border: 1px solid white;
  width: 6px;
  height: 6px;
  border-radius: 3px;
}

@media (min-width: 1200px) {
  .background-gradient-red {
    height: 320px;
  }
}
</style>
